<template>
  <div class="editQualityCheck" style="border:1px solid #e0e0e0;">
    <div class="titleForm-container">编辑质检机构信息</div>
    <div class="content-form-container">
      <div class="main-container-form">
        <el-form :model="baseForm" :rules="rules" ref="baseForm" label-width="90px" class="ruleForm">
          <el-form-item label="机构名称" prop="name">
            <el-input v-model="baseForm.name" size="medium" style="width:100%;" placeholder="请输入机构全称" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" :maxlength="num50">
            </el-input>
          </el-form-item>
          <el-form-item label="联系人" prop="leader">
            <el-input v-model="baseForm.leader" size="medium" style="width:100%;" placeholder="请输入真实姓名" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" :maxlength="num20">
            </el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="phone">
            <el-input v-model="baseForm.phone" size="medium" style="width:100%;" placeholder="请输入联系电话" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" :maxlength="num11">
            </el-input>
          </el-form-item>
           <el-row :gutter="5">
            <el-form-item label="机构地址" required>
              <el-col :span="8">
                <el-form-item prop="areaId">
                  <el-select v-model="baseForm.provinceNo" placeholder="请选择省份" size="medium" style="width:100%;" @change="selectProvince" >
                    <el-option v-for="item in provinces" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item prop="cityNo" v-if="citys.length>0" >
                  <el-select v-model="baseForm.cityNo" placeholder="请选择市" size="medium" style="width:100%;" @change="selectCity">
                    <el-option v-for="item in citys" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item prop="countyNo" v-if="countys.length>0">
                  <el-select v-model="baseForm.countyNo" placeholder="请选择县" size="medium" style="width:100%;">
                    <el-option v-for="item in countys" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-form-item>
          </el-row>
          <el-form-item label="详细地址" prop="address">
            <el-input v-model="baseForm.address" size="medium" style="width:100%;" type="text" :maxlength="num50" placeholder="详细地址不得少于2个字符" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"></el-input>
          </el-form-item>
          <el-form-item label="相关图片" prop="images">
            <el-upload
              style="width:1200px;"
              :action="uploadURl"
              :class="{qhide:hideUpload}"
              :on-change="handleChange"
              list-type="picture-card"
              :file-list="fileList"
              :with-credentials="true"
              :before-upload="beforeUpload"
              :on-success="handleSuccess"
              :on-remove="handleRemove">
              <i class="el-icon-plus">
                <h4 class="upload-tip">最多上传四张jpg/png图片，且不超过500kb</h4>
              </i>
            </el-upload>
            
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
          </el-form-item>
          <el-form-item class="save-cancel" v-if="edit">
            <el-col :span="8">
              <el-button class="save-btn" @click="saveBase('baseForm')">保存</el-button>
            </el-col>
            <el-col :span="8">
              <el-button class="cancel-btn" @click="cancelForm('ruleForm')">取消</el-button>
            </el-col>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>


<script>
import { mapActions, mapState } from "vuex";
import { modules } from "../../../store";
import imgUpload from "../../../service/base-url";
import mixins from "@/common/MixIn.js";
export default {
  name: "EditQualityCheck",
  mixins: [mixins],
  data() {
    return {
      dialogImageUrl: "",
      dialogVisible: false,
      num20: 20,
      num11: 11,
      num50: 50,
      citys: [],
      countys: [],
      hideUpload: false,
      // defaultImg: [
      //   {
      //     name: "food.jpeg",
      //     url: require("../../../assets/images/qualityTracing/img_inspection@2x.png")
      //   }
      // ],
      fileList: [],
      index: "",
      // 参数
      baseForm: {
        id: "",
        name: "",
        leader: "", // 联系人
        phone: "",
        provinceNo: "", // 省份
        cityNo: "", // 城市
        countyNo: "", // 辖区
        address: "", // 详细地址
        images: [] //图片
      },
      // 校验规则
      rules: {
        name: [
          {
            required: true,
            message: "请先输入机构全称",
            trigger: "blur"
          }
          // {
          //   pattern: /^[a-zA-Z0-9_\u4e00-\u9fa5]+$/,
          //   message: "基地名称格式不对,请重新输入"
          // }
        ],
        leader: [
          { required: true, message: "请先输入真实姓名", trigger: "blur" },
          {
            pattern: /^[a-zA-Z\u4e00-\u9fa5]+$/,
            message: "真实姓名格式不对,请重新输入"
          }
        ],
        phone: [
          { required: true, message: "请先填写联系电话" },
          // { type: "number", message: "联系电话必须为数字" },
          {
            pattern: /^1[3|4|5|7|8|9][0-9]\d{8}$/,
            message: "联系电话格式不对,请重新输入"
          }
        ],
        provinceNo: [
          { required: true, message: "请先选择省份", trigger: "change" }
        ],
        cityNo: [{ required: true, message: "请先选择市", trigger: "change" }],
        countyNo: [
          { required: true, message: "请先选择县", trigger: "change" }
        ],
        address: [
          { required: true, message: "请先输入详细地址", trigger: "blur" }
          // {
          //   pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+$/,
          //   message: "详细地址格式不对,请重新输入",
          //   min: 2
          // }
        ]
      },
      uploadURl: imgUpload.imgUpload // 文件上传地址
    };
  },
  async mounted() {
    await this.initPagePermission();
    let result = await this.getEditQualityCheckManage(this.$route.query.id);
    //获取 图片,附件信息  进行分别展示
    if (result.images.length >= 4) {
      this.hideUpload = true;
    } else {
      this.hideUpload = false;
    }
    this.distribution(result.images);
    this.baseForm.id = result.id;
    this.baseForm.name = result.name;
    this.baseForm.leader = result.leader;
    this.baseForm.address = result.address;
    this.baseForm.phone = result.phone;
    this.baseForm.provinceNo = result.provinceId;
    await this.selectProvince();
    this.baseForm.cityNo = result.cityId;
    await this.selectCity();
    this.baseForm.countyNo = result.countyId;
    this.getProvinces();
    console.log(1222, result.images);
  },
  computed: {
    ...mapState(modules.area, {
      provinces: "provinces"
    })
  },
  methods: {
    ...mapActions(modules.qualityCheck, {
      getEditQualityCheckManage: "getEditQualityCheckManage",
      editQualityCheckManage: "editQualityCheckManage"
    }),
    ...mapActions(modules.area, {
      getProvinces: "getProvinces",
      getArea: "getArea"
    }),
    handleChange(file, fileLis) {
      if (fileLis.length >= 4) {
        this.hideUpload = true;
      } else {
        this.hideUpload = false;
      }
      console.log(this.hideUpload);
    },
    // 展示 图片和附件
    distribution(arr) {
      arr.forEach(ele => {
        this.fileList.push({
          name: ele.title,
          id: ele.name,
          url: this.uploadURl + "/" + ele.name
        });
        this.baseForm.images.push(ele.name);
      });
    },
    //省份获取之后 获取对应的城市
    async selectProvince() {
      let obj = {
        parentNo: this.baseForm.provinceNo
      };
      let result = await this.getArea(obj);
      this.citys = result;
      this.baseForm.cityNo = null;
      this.baseForm.countyNo = null;
      this.countys = [];
    },
    // 城市获取之后 获取对应的县市
    async selectCity() {
      let obj = {
        parentNo: this.baseForm.cityNo
      };
      let result = await this.getArea(obj);
      this.countys = result;
      this.baseForm.countyNo = null;
    },
    judgeImgLength(fileList) {
      // if (this.baseForm.images.length == 0) {
      //   this.fileList = this.defaultImg;
      // } else {
      if (fileList.length != this.baseForm.images.length) {
        this.fileList = fileList.splice(1, 1);
      } else {
        this.fileList = fileList;
      }
      // }
    },
    // 图片上传之前
    beforeUpload(file) {
      const isImg = file.type === "image/jpeg" || file.type === "image/png";
      const isLt500KB = file.size / 1024 / 1024 < 0.5;
      if (!isImg) {
        this.$Alert.info({
          content: "上传图片只能是JPG/png格式!",
          duration: 3000,
          status: "error"
        });
        return isImg && isLt500KB;
      }
      if (!isLt500KB) {
        this.$Alert.info({
          content: "上传图片大小不能超过500kb!",
          duration: 3000,
          status: "error"
        });
        return isImg && isLt500KB;
      }
      if (this.baseForm.images.length >= 4) {
        this.$Alert.info({
          content: "最多上传四张图片",
          duration: 3000,
          status: "error"
        });
        return false;
      }
    },
    // 文件上传成功
    handleSuccess(res, file, fileList) {
      this.baseForm.images.push(res.name);
      this.judgeImgLength(fileList);
    },
    // 文件移除
    handleRemove(file, fileList) {
      if (file.id) {
        this.index = this.baseForm.images.indexOf(file.id);
      } else if (file.response) {
        this.index = this.baseForm.images.indexOf(file.response.name);
      } else {
        let urlSlashCount = file.url.split("/").length; // 统计有3斜杠
        let str = file.url.split("/")[urlSlashCount - 1].toLowerCase(); //获取数组最后一个
        this.index = this.baseForm.images.indexOf(str);
      }
      if (this.index != -1) {
        this.baseForm.images.splice(this.index, 1);
        this.judgeImgLength(fileList);
      }
      if (fileList.length >= 4) {
        this.hideUpload = true;
      } else {
        this.hideUpload = false;
      }
    },
    //保存
    async saveBase(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          // 参数
          let obj = {
            id: this.baseForm.id,
            name: this.baseForm.name,
            leader: this.baseForm.leader,
            phone: this.baseForm.phone,
            areaId:
              this.baseForm.countyNo ||
              this.baseForm.cityNo ||
              this.baseForm.provinceNo,
            address: this.baseForm.address,
            images: this.baseForm.images
          };
          // post 请求
          this.editQualityCheckManage(obj)
            .then(data => {
              this.$message({
                message: "保存成功",
                type: "success"
              });
              this.$router.push({
                name: "qualityCheckList"
              });
            })
            .catch(err => {
              this.$Alert.info({
                content: err.response.data,
                duration: 5000,
                status: "error"
              });
            });
        } else {
          return false;
        }
      });
    },
    //取消
    cancelForm() {
      this.$router.push({
        name: "qualityCheckList"
      });
    }
  }
};
</script>

<style lang="stylus">
.editQualityCheck
  .qhide .el-upload--picture-card 
    display: none;
  .el-upload--picture-card
    float left 
    margin-right 10px;
</style>


<style lang="stylus" scoped>
 .save-btn,.cancel-btn
    margin-top:20px;
  .upload-tip
    position absolute
    top:150px;
    font-size:14px;
  // .default-img{
  //   width:148px;
  //   height:148px;
  // }
</style>
